import axios from '../../common/utils/interceptor';
import { apiUrls, defaultBranding } from '../../constants';
import { WorkflowItem } from '../../store/interfaces';
import localizeContentMapper from '../../common/utils/localizeContentMapper';
import { SessionStore } from '../../constants/sessionStore';

/** Api call to revalidate session */
export const reValidateSession = async (queryParams = ''): Promise<{ data?: WorkflowItem; error: string }> => {
  const res = { data: undefined, error: '' };

  try {
    let url = apiUrls.REVALIDATE_SESSION;
    if (queryParams !== '') {
      url = `${url}?${queryParams}`;
    }
    const { data } = await axios.get(url);

    if (data.IsError) {
      res.error = data.Message;
    } else {
      sessionStorage.setItem(SessionStore.currentWorkflowItem, JSON.stringify(data.workflowItem));

      res.data = data.workflowItem;

      if (data.template && data.template.id) {
        // Fallback to default settings in case its null
        const parsedTemplateSettings = data.template.settings ? JSON.parse(data.template.settings) : defaultBranding;
        const template = {
          ...data.template,
          settings: localizeContentMapper(parsedTemplateSettings, data.template.localizedContentMap),
        };
        sessionStorage.setItem(SessionStore.template, JSON.stringify(template));
      }

      if (data.workflowSession) {
        const formStatusString = sessionStorage.getItem(SessionStore.formStatus);
        const formStatus = formStatusString && JSON.parse(formStatusString);
        sessionStorage.setItem(SessionStore.workflowSession, JSON.stringify(data.workflowSession));
        //used to set welcomePageSubmitted key again in order to avoid showing the welcome page again and again
        if (data.workflowSession?.formStatus) {
          const wfFormStatus = JSON.parse(data.workflowSession.formStatus);
          if (formStatus && formStatus.welcomePageSubmitted) {
            wfFormStatus.welcomePageSubmitted = true;
          }
          sessionStorage.setItem(SessionStore.formStatus, JSON.stringify(wfFormStatus));
        }
      }
    }
  } catch (e) {
    res.error = 'error';
    if (e) {
      res.error = (e.data && e.data.Message) || e.message;
    }
  }
  return res;
};
